import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, TYPEMESSAGE, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { UserService } from '../../user/shared/user.service';
import { RolUserService } from '../shared/rolUser.service'
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { rolUser, IrolUser } from '../shared/rolUser.model'

@Component({
  selector: 'app-roluser',
  // styleUrls: ['table-basic-example.css'],
  templateUrl: 'rolUser.component.html',
})

export class RolUserListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;
  @Input() ID: number;

  // dataSource = ELEMENT_DATA;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[] = ['indCheck', 'AplicacionName', 'OfficeName', 'RoleName', 'AplicacionID', 'RoleID', 'OfficeID', 'ID', 'Name', 'Password', 'Descripcion', 'Status'];
  dataSource: GridDataSource; //MatTableDataSource<Iaplicacion>;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;
  rolUSer: IrolUser;

  constructor(private loaderService: LoaderService, private userService: UserService,
    private errorService: ErrorService, private notificationService: NotificationService,
    private rolUserService: RolUserService,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.pageSize = CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.titlePage = 'Roles Usuarios ';
    this.msgErrorGet = 'Error al listar los Roles / Aplicacion';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
    this.buscarUser("");
  }

  handleRowClick(row: any, event: any, rowNum: number) {
    this.selectedRowIndex = row.rownum;
    this.data.aplicacion = { codVersion: row.codVersion };
    this.changeEvent({ evento: EVENTO.consultar, data: this.data });
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscarUser(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    this.listarUser(this.sectionBarComponent.filtro);
  }

  buscarUser(filtro: string) {
    this.clearMatPaginator();
    this.listarUser(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  private listarUser(filtro: string): void {
    /*this.loaderService.show();
    this.userService.listarUserAccess(0, 0, 0, filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
      .subscribe(res => {
        if (this.errorService.getMessageError(res)) {
          this.dataSource = new GridDataSource(res);
          this.showHideMessageGridEmpty(Number(res.length));
          this.pageEvent.length = res.length;
          this.setMatPaginator();
        }
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });*/
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }

  onChangeVinculacion(event: any, row: any) {
    let RoleID: number;
    if (event.checked)
      RoleID = 1;
    else
      RoleID = row.RoleID
    this.toggleRolUser(row.ID, 1, 1, 1, event.checked)
  }

  private toggleRolUser(UserID: number, AplicacionID: number, RoleID: number, OfficeID: number, pToggle: boolean): void {
    this.loaderService.show();
    this.rolUserService.ToggleRolUser(UserID, AplicacionID, RoleID, OfficeID, pToggle)
      .subscribe(res => {
        // if (this.errorService.getResultMessageError2(res)) {
        //this.notificationService.showMessage(res.Data.mensaje, TYPEMESSAGE.Correcto);
        // }
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          // this.notificationService.showMessage(this.msgErrorToggleVincularCorreoAfiliado, TYPEMESSAGE.Error);
          throw error;
        },
        () => {
          this.loaderService.hide();
          // this.listarCorreosAfiliado(this.data.codAfiliado);
        });
  }
}

